import React, { memo } from "react"
import PropTypes from "prop-types"
import styles from "../../styles/components/StoreLocator/StoreLocator-tw-styles"
import {
    BaiduMap,
    Marker,
    asyncWrapper,
    NavigationControl,
} from "react-baidu-maps"

function Map(props) {
    const AsyncBaiduMap = asyncWrapper(BaiduMap)
    const {
        zoom,
        center,
        onLoadMap,
        changeMarker,
        allStores,
        apiKey,
        updateStore,
    } = props
    return (
        <AsyncBaiduMap
            zoom={zoom}
            enableDragging
            enableScrollWheelZoom
            enableDoubleClickZoom
            enableMapClick
            center={center}
            mapUrl={`https://api.map.baidu.com/api?v=2.0&ak=${apiKey}`}
            loadingElement={<span>Loading map...</span>}
            mapContainer={
                <div
                    className={styles.mapContainer}
                    style={{ height: "100%", width: "100%" }}
                />
            }
            onMapInstantiated={instance => {
                onLoadMap(instance)
            }}
            onZoomend={updateStore}
            onDragend={updateStore}
            onClick={e => console.warn("map click :", e.point)}
        >
            <NavigationControl
                type='BMAP_NAVIGATION_CONTROL_ZOOM'
                anchor='bottom_right'
                offset={{ width: 0, height: 30 }}
            />
            {allStores.map((position, index) => (
                <Marker
                    title ={position.name}
                    key={index}
                    position={{ lng: position.lan, lat: position.lat }}
                    onClick={() => changeMarker(position)} />
            ))
            }
        </AsyncBaiduMap >
    )
}

Map.propTypes = {
    mapStyle: PropTypes.array,
    zoom: PropTypes.number,
    center: PropTypes.object,
    onLoadMap: PropTypes.func,
    updateStore: PropTypes.func,
    maxZoomCluster: PropTypes.number,
    onClusterClick: PropTypes.func,
    changeMarker: PropTypes.func,
    allStores: PropTypes.array,
    apiKey: PropTypes.string,
}

export default memo(Map)
